import { InverseHeader } from '@jouzen/ecom-components/layout';

import ScienceAndResearchHeroOR4 from './ScienceAndResearchHeroOR4';

const ScienceAndResearchHero = () => {
  return (
    <div data-cy="science-and-research-hero">
      <InverseHeader enter>
        <ScienceAndResearchHeroOR4 />
      </InverseHeader>
    </div>
  );
};

export default ScienceAndResearchHero;
